import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';
import rootReducer from './reducer';
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'
import { createStore, applyMiddleware } from 'redux'
import { Router, Route, hashHistory, IndexRoute } from 'react-router'
import { syncHistoryWithStore, routerMiddleware } from 'react-router-redux'
import Loadable from 'react-loadable';
import ErrorBoundary from './ErrorBoundary';

import './App.css';
///import Navi from './navi/Navi'
///import DailyLog from './navi/DailyLog'

///import LoginPage from './page/LoginPage'
// import ReLoginPage from './page/ReLoginPage'

///import AppPdfDetail from './page/AppPdfDetail'
///import ProjectManagementDetail from './page/ProjectManagementDetail'
//import IndexPage from './page/IndexPage'
///import AppDownload from './page/AppDownload'
///import AppPrivate from './page/AppPrivate'
///import ExaminationQuestionDetail from './page/OnlineTrainingPages/ExaminationQuestionDetail'
///import ExaminationDetail from './page/OnlineTrainingPages/ExaminationDetail'
///import TestpaperReplay from './page/OnlineTrainingPages/TestpaperReplay'

import { ConfigProvider } from 'antd';
import moment from 'moment';
import zhCN from 'antd/es/locale/zh_CN';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const Loading = () => <div>Loading...</div>;
const Navi = Loadable({
  loader: () => import('./navi/Navi'),
  loading: Loading,
});

const DailyLog = Loadable({
  loader: () => import('./navi/DailyLog'),
  loading: Loading,
});

const LoginPage = Loadable({
  loader: () => import('./page/LoginPage'),
  loading: Loading,
});

const IndexPage = Loadable({
  loader: () => import('./page/IndexPage'),
  loading: Loading,
});

const AppPdfDetail = Loadable({
  loader: () => import('./page/AppPdfDetail'),
  loading: Loading,
});

const ProjectManagementDetail = Loadable({
  loader: () => import('./page/ProjectManagementDetail'),
  loading: Loading,
});

const AppDownload = Loadable({
  loader: () => import('./page/AppDownload'),
  loading: Loading,
});

const AppShowManual = Loadable({
  loader: () => import('./page/ElectronicManual/AppShowManual'),
  loading: Loading,
});

const AppPrivate = Loadable({
  loader: () => import('./page/AppPrivate'),
  loading: Loading,
});

const ExaminationQuestionDetail = Loadable({
  loader: () => import('./page/OnlineTrainingPages/ExaminationQuestionDetail'),
  loading: Loading,
});

const ExaminationDetail = Loadable({
  loader: () => import('./page/OnlineTrainingPages/ExaminationDetail'),
  loading: Loading,
});

const TestpaperReplay = Loadable({
  loader: () => import('./page/OnlineTrainingPages/TestpaperReplay'),
  loading: Loading,
});

const ExpertsQADetail = Loadable({
  loader: () => import('./page/ExpertsQA/ExpertsQADetail'),
  loading: Loading,
});




const loggerMiddleware = createLogger({
  predicate: (getState, action) => {
    if (!action.type) return false
    return !action.type.includes('@@')
  },
  collapsed: (getState, action, logEntry) => !logEntry.error,
})
const middleware = routerMiddleware(hashHistory)

const store = createStore(
  rootReducer,
  applyMiddleware(
    middleware,
    thunkMiddleware, // lets us dispatch() functions
    loggerMiddleware // neat middleware that logs actions
  )
)
const history = syncHistoryWithStore(hashHistory, store)
window.carrHistory = history
const Root = ({ store }) => (
  <ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <Router history={history}>
        <Route path="/" component={IndexPage}>
          <IndexRoute component={LoginPage} />
          <Route path="login" component={LoginPage} />
          {/* <Route path="relogin" component={ReLoginPage} /> */}
          <Route path="kb" component={Navi} />
          <Route path="dailyLog" component={DailyLog} />
        </Route>
        <Route path="kb/appPdfDetail" component={AppPdfDetail} />
        <Route path="app/download" component={AppDownload} />
        <Route path="app/manual" component={AppShowManual} />
        <Route path="app/private" component={AppPrivate} />
        {/* <Route path=" .well-known" component={AppPrivate} /> */}
        <Route path="dailyLog/projectManagementDetail" component={ProjectManagementDetail} />
        <Route path="kb/singleChoiceDetail" component={ExaminationQuestionDetail} />
        <Route path="kb/examinationDetail" component={ExaminationDetail} />
        <Route path="kb/testpaperReplay" component={TestpaperReplay} />
        <Route path="kb/ExpertsQADetail" component={ExpertsQADetail} />
        {/* </Route> */}
      </Router>
    </Provider>
  </ConfigProvider>
)
ReactDOM.render(<Root store={store} />, document.getElementById('root'))

serviceWorker.unregister();